import Grid from "@mui/material/Grid";

import LoadingUpAnimation from "../../components/LoadingUpAnimation";
import HomepageComponentsFromJson from "../../components/newHomePage/HomepageComponentsFromJson";
import HomepageContainer from "../../components/newHomePage/HomepageContainer/HomepageContainer";
import HomepageHeaderContainer from "../../components/newHomePage/HomepageHeaderContainer/HomepageHeaderContainer";
import HomepageHeaderGreeting from "../../components/newHomePage/HomepageHeaderGreeting/HomepageHeaderGreeting";
import { Content } from "../../components/newHomePage/utils/homepageJson.types";
import InstallApp from "../../components/popUp/InstallApp";
import useFetchRecipesAndIngredients from "../../hooks/useFetchRecipesAndIngredients/useFetchRecipesAndIngredients";
import HomepagePublicLoginButton from "./HomepagePublicLoginButton";
import styles from "./PublicHomepage.module.css";
import usePublicHomepage from "./usePublicHomepage";

const PublicHomepage = () => {
  const { loading: fetchingPublicAndIngredients } = useFetchRecipesAndIngredients();

  const { defaultHomeConfig, loading: fetchingCategoryToRecipeId } = usePublicHomepage();

  if (fetchingPublicAndIngredients || fetchingCategoryToRecipeId) return <LoadingUpAnimation />; 

  return (
    <>
      <InstallApp />
      <HomepageContainer>
        <HomepageHeaderContainer>
          <HomepageHeaderGreeting />
          <HomepagePublicLoginButton />
        </HomepageHeaderContainer>
        <Grid className={styles.contentWrapper} id="components_from_json">
          {defaultHomeConfig?.contents?.map((data: Content) => (
            <HomepageComponentsFromJson
              data={data}
              homePageRow={data.homePageRow}
              key={data.id}
              viewedHomePageRow={data.viewedHomePageRow} />
          ))}
        </Grid>
      </HomepageContainer>
    </>
  )
}

export default PublicHomepage